<div class="side-sheet" [ngClass]="{'active': currentOrderId}">
  <div class="d-flex h-100">

    <div class="overlay" (click)="close.emit()"></div>

    <div class="sheet-container checkout">
      <div class="sheet-head">
        <div class="title">{{'orders.Payment Details' | translate}}</div>

        <button type="button" mat-icon-button (click)="close.emit()">
          <img src="./assets/images/icons/close.svg" alt="">
        </button>
      </div>

      <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>

      <ng-container *ngIf="!dataLoading">
        <div class="sheet-content">

          <app-prices-details [orderDetails]="details"></app-prices-details>

          <app-paid-list [orderDetails]="details"></app-paid-list>

        </div>
      </ng-container>
    </div>
  </div>
</div>
